<template>
  <div class="plant-summary__card">
    <div :style="{ display: 'flex', flexDirection: 'column', alignItem: 'center' }">
      <div class="header-title text-xs-center">
        {{ $t('Performance Summary') }}
        <v-tooltip color="bg" bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">info</v-icon>
          </template>
          <div id="hover__card" class="tool-tip__color">
            <h2 class="text-xs-center">{{ $t('Performance info') }}</h2>
            <MapLegend v-for="map in mapsLabel" :key="map.name" :text="map.name"
              :shape="map.attr" />
          </div>
        </v-tooltip>
      </div>
      <div class="header-info text-xs-center">
        {{ $t('viewing based on') }} {{ `${$t(basedOn)} ${dateInfo}` }}
      </div>
    </div>

    <GlobalGraph class="plant-summary__graph" :isMagicType="false" :series="[{
        name: `${$t('Overall Performance based on')} ${$t(basedOn)}`,
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 1
        },
        data: computedGraphData
      }]" :graphID="'plantSummary'" :isHoverFix="false" :theme="theme" />
  </div>
</template>

<script>
import _ from 'lodash'
import MapLegend from '@/components/common/MapLegend'
import {
  mapGettersMixin
} from '@/util/mixin/index.js'

export default {
  components: {
    MapLegend
  },
  mixins: [mapGettersMixin],
  props: {
    graphData: {
      type: Array,
      default: function () {
        return []
      }
    },
    info: {
      type: Object,
      default: function () {
        return {
          best: '',
          average: '',
          least: ''
        }
      }
    },
    basedOn: {
      type: String,
      default: ''
    },
    dateRangeType: {
      type: String,
      default: ''
    },
    dateFrom: {
      type: String,
      default: ''
    },
    dateTo: {
      type: String,
      default: ''
    }
  },
  computed: {
    mapsLabel() {
      return [{
        name: `${this.$t('Best')}: ${this.info.best}`,
        attr: {
          name: 'circle',
          color: '#1FCF8E'
        }
      },
      {
        name: `${this.$t('Average')}: ${this.info.average}`,
        attr: {
          name: 'circle',
          color: '#E6DB72'
        }
      },
      {
        name: `${this.$t('Least')}: ${this.info.least}`,
        attr: {
          name: 'circle',
          color: '#F66747'
        }
      }
      ]
    },
    computedGraphData() {
      const clonedData = _.cloneDeep(this.graphData)
      return clonedData.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    },
    dateInfo() {
      if (this.dateRangeType === 'Custom') {
        return `${this.$t('from')} ${this.dateFrom} ${this.$t('to')} ${this.dateTo}`
      } else {
        return `${this.$t('for')} ${this.$t(this.dateRangeType)}`
      }
    }
  },
}
</script>

<style scoped>
.plant-summary__card {
  height: 50.5vh;
  background-color: var(--v-primary-base);
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 19px;
  padding-top: 10px;
}

.header-info {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  padding-top: 3px;
}

.plant-summary__graph {
  width: 100%;
  height: 43vh;
}

#hover__card {
  width: 400px;
  padding: 10px;
}
</style>
